<template>
    <form action="" method="post" enctype="multipart/form-data" class="settings_signature mt-4" >
        <input type="file" name="files" ref="file" class="files"  
            :data-fileuploader-files='ploadsignature'
            />
    </form>
</template>

<script>
    export default {
        props: ['ploadsignature'],
        data() {
            return {
                file: null,
            }
        },
        methods: {
            sendData(){
                this.$emit('data', this.file);
            }
        },
        mounted () {
            var t = this
            $(document).ready(function() {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $(".settings_signature input.files").fileuploader({
                    limit: 1,
                    extensions: ["jpg", "png", "svg"],
                    fileMaxSize: 2,
                    changeInput:
                                '<div class="fileuploader-input">' +
                                '<span class="top_left">' + t.$t('company.signature_text_0') + '</span>'+
                                '<div class="fileuploader-input-inner">' +
                                '<div class="fileuploader-icon-main"></div>' +
                                '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                                "<p>${captions.or}</p>" +
                                "</div>" +
                                "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        onImageLoaded: function(item) {
                            t.file = item.file
                            if (!item.html.find(".fileuploader-action-edit").length)
                                item.html
                                    .find(".fileuploader-action-remove")
                                    .before(
                                        '<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Uraviť">' +
                                            '<i class="fileuploader-icon-edit"></i></button>'
                                    );

                            if (item.imageIsUploading) {
                                item.image.addClass("fileuploader-loading").html("");
                            }
                            t.sendData()
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: t.$t('company.signature_text_1'),
                        feedback2: t.$t('company.signature_text_2'),
                        drop: t.$t('company.signature_text_3'),
                        or: t.$t('company.signature_text_4'),
                        button: t.$t('company.signature_text_5'),
                        remove: t.$t('company.signature_text_6'),
                        download: t.$t('company.signature_text_7'),
                        removeConfirmation: t.$t('company.signature_text_8'),
                        errors: {
                            filesLimit: function(e) {
                                    t.$toast.warning(t.$t('company.signature_text_9'), {
                                        timeout: 5000,
                                    })
                            },
                            filesType: function(e) {
                                    t.$toast.warning(t.$t('company.signature_text_10', { extensions: e.extensions }), {
                                        timeout: 5000,
                                    })
                            },
                            fileSize: function(e) {
                                    t.$toast.warning(t.$t('company.signature_text_11', { name: e.name, fileMaxSize: e.fileMaxSize }), {
                                        timeout: 5000,
                                    })
                            }
                        }
                    }),

                    onRemove: function(item) {
                        t.file = null
                        axios.post('/api/firma/logo/remove', { file: item.name, type: 1 })
                        t.sendData()
                    },
                });
            })
        },
        
    }

</script>

<style lang="scss">
.settings_signature {
    .fileuploader{
        background: transparent;
        margin: 0;
        padding: 0;
    }
    .fileuploader-theme-dragdrop .fileuploader-input{
        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 91px;
        .top_left{
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }
        .fileuploader-input-inner{    
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main{
        margin: 0;
        font-size: 32px;
    }
    h3.fileuploader-input-caption{
        text-align: start;
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
         span{
            font-weight: normal;
            color: #263544;
        }
        .nahraj{
            font-weight: 600;
            color: #2ED8B6;
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss" scoped>
form{
    width: 100%;
    margin: 0 auto;
    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
</style>